<template>
    <div>

        <!-- Status -->
        <sau-service-status :service="service"></sau-service-status>

        <!-- System Details -->
        <template v-if="service.custom">
            <sau-service-common-system :service="service" class="pt-12"></sau-service-common-system>
        </template>

        <!-- Bandwidth -->
        <sau-bandwidth-graph  v-if="showBandwidth && checked" class="pt-12" :service="service"></sau-bandwidth-graph>

        <!-- Pending Cancellation - now checked in sau-service-status -->
        <!-- <sau-cancellation-check class="pt-12"></sau-cancellation-check> -->

    </div>
</template>

<script>
export default {
    props:['service'],
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
    },
    computed: {
    }
}
</script>

<style>
</style>
